<div class="box-contact">
    <p>
        We'd love to hear from you! Whether you have questions about our datasets, want to explore a partnership, or
        need support, feel free to reach out.
    </p>
    <h6 class="mb-3">
        <strong>General Inquiry Form</strong>
    </h6>
    <form nz-form [formGroup]="contactForm" (ngSubmit)="submitForm()">
        <nz-form-item *ngFor="let key of objectKeys(propMap)">
            <nz-form-label [nzLg]="8" [nzMd]="8" [nzSm]="8" [nzXs]="24" [nzFor]="key"
                           [nzRequired]="propMap[key]?.required">
                {{ propMap[key]?.label }}
            </nz-form-label>
            <nz-form-control [nzLg]="16" [nzMd]="16" [nzSm]="16" [nzXs]="24"
                             [nzErrorTip]="getErrorMessage(key)">
                <ng-container [ngSwitch]="propMap[key]?.type">

                    <!-- Select Dropdown -->
                    <nz-select *ngSwitchCase="'select'" [formControlName]="key"
                               [nzPlaceHolder]="propMap[key]?.placeholder">
                        <nz-option *ngFor="let option of propMap[key]?.options" [nzValue]="option?.['value']"
                                   [nzLabel]="option?.['label']"></nz-option>
                        <nz-option *ngIf="propMap[key]?.hasOtherOption" nzValue="Other" nzLabel="Other"></nz-option>
                    </nz-select>

                    <!-- Textarea for Message -->
                    <textarea *ngSwitchCase="'textarea'" nz-input [formControlName]="key"
                              [placeholder]="propMap[key]?.placeholder"></textarea>

                    <!-- Default Input (text, email, etc.) -->
                    <input *ngSwitchDefault nz-input [formControlName]="key" [type]="propMap[key]?.type || 'text'"
                           [placeholder]="propMap[key]?.placeholder"/>
                    <label *ngSwitchCase="'checkbox'" nz-checkbox [formControlName]="key"
                           [placeholder]="propMap[key]?.placeholder"></label>

                </ng-container>
            </nz-form-control>
        </nz-form-item>
        <nz-form-item>
            <nz-form-control>
                <button nz-button nzType="primary" [nzLoading]="loading" [disabled]="!contactForm.valid">
                    Submit
                </button>
            </nz-form-control>
        </nz-form-item>
    </form>

    <hr/>
    <h6>
        <strong>Or reach us directly at:</strong>
    </h6>
    <p>
        <strong>Email: </strong><a href="mailto:contact@datacore.vn">contact&#64;datacore.vn</a>
    </p>

</div>
